"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var xml_utils_1 = require("xml-utils");
var find_operations_1 = __importDefault(require("./find-operations"));
function findOperation(xml, name) {
    var _a;
    return (_a = (0, find_operations_1.default)(xml)) === null || _a === void 0 ? void 0 : _a.find(function (op) { return (0, xml_utils_1.getAttribute)(op, "name") === name; });
}
exports.default = findOperation;
